/**
 * Observability constants: storage keys, header names, feature flag.
 * Align with OBSERVABILITY_FINAL_PLAN.md and reuse guide.
 */

const OBSERVABILITY_ENABLED_ENV =
  typeof process !== 'undefined' ? process.env?.REACT_APP_OBSERVABILITY_ENABLED : undefined;

/** When 'true', observability is enabled. Omit or 'false' disables. */
export const OBSERVABILITY_ENABLED = OBSERVABILITY_ENABLED_ENV === 'true';

export const DEVICE_ID_STORAGE_KEY = 'observability_device_id';
export const SESSION_ID_STORAGE_KEY = 'observability_session_id';

export const HEADER_DEVICE_ID = 'x-device-id';
export const HEADER_APP_NAME = 'x-app-name';
export const HEADER_TRACEPARENT = 'traceparent';

export const DEFAULT_APP_NAME = 'safety-village-cms';
